import { setCookie as h3SetCookie } from 'h3'
import type { CookieOptions } from 'nuxt/app'

type CommonCookieOptions = Pick<
	CookieOptions<string>,
	'path' | 'domain' | 'expires' | 'maxAge' | 'sameSite' | 'secure' | 'httpOnly'
>

/**
 * Sets a cookie in a way that works on both server (via h3) and client (via Nuxt's `useCookie`).
 * Defaults to `path: '/'`, `sameSite: 'lax'`, and `secure: true` in production.
 * @param key - Cookie name.
 * @param val - Cookie value.
 * @param opts - Optional overrides for path, domain, maxAge, etc.
 */
export function setCookieUniversal(key: string, val: string, opts: CommonCookieOptions = {}) {
	const base: CommonCookieOptions = {
		path: '/',
		sameSite: 'lax',
		secure: process.env.NODE_ENV === 'production',
	}

	if (import.meta.server) {
		const event = useRequestEvent()
		if (event) {
			h3SetCookie(event, key, val, { ...base, ...opts })
			return
		}
	}

	useCookie<string>(key, { ...base, ...opts }).value = val
}
